import AoneService from "../axiosbase";
// Get Delivery task
export const getDeliveryTask = async (params) => {
    try {
        return await AoneService.get(`ops/api/v1/delivery/task${params}`)
    } catch (error) {
        return error;
    }
}
// Get Delivery task version 2
export const getDeliveryTasks = async (params) => {
    try {
        return await AoneService.get(`ops/api/v2.1/delivery/task${params}`)
    } catch (error) {
        return error;
    }
}
//create delivery task
export const postDeliveryTask = async (data) => {
    try {
        return await AoneService.post(`ops/api/v1/delivery/task`,data)
    } catch (error) {
        return error;
    }
}
//assign bulk couriers
export const bulkAssignDeliveryTask = async (data) => {
    try {
        return await AoneService.post(`ops/api/v1/delivery/task/bulk`,data)
    } catch (error) {
        return error;
    }
}
//delivery task export
export const exportDeliveryTasks = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/delivery/task/export${params}`, {
        responseType: "blob",
      });
    } catch (error) {
      return error;
    }
  };
//delivery task template
export const DeliveryTaskTemplate = async () => {
    try {
      return await AoneService.get(
        `ops/api/v1/delivery/task/template/download`,
        {
          responseType: "blob",
        }
      );
    } catch (error) {
      return error;
    }
  };
//bulk import delivery tasks
export const importDeliveryTasks = async (data) => {
    try {
      return await AoneService.post(`ops/api/v1/delivery/task/import`, data, {
        "Content-Type": "multipart/form-data",
      });
    } catch (error) {
      return error;
    }
  };

//validate delivery task
export const validateDeliveryTask = async (params) => {
    try {
        return await AoneService.post(`ops/api/v1/delivery/task/${params}/validate`)
    } catch (error) {
        return error;
    }
}
//count employee for delivery task
export const countEmployee = async (params) => {
    try {
        return await AoneService.post(`ops/api/v1/delivery/task/${params}/count`)
    } catch (error) {
        return error;
    }
}
//unassign delivery task
export const removeDeliveryTask = async (params) => {
    try {
        return await AoneService.delete(`ops/api/v1/delivery/task/${params}`)
    } catch (error) {
        return error;
    }
}
//delivery status lookup
export const getdeliveryStatus = async () => {
    try {
        return await AoneService.get(`ops/api/v1/lookups/DeliveryTaskStatus`)
    } catch (error) {
        return error;
    }
}

//delivery validation
//get delivery validation
export const getdeliveryValidation = async (params) => {
    try {
        return await AoneService.get(`ops/api/v1/delivery/validations/${params}/scans`)
    } catch (error) {
        return error;
    }
}
//post delivery validation
export const postdeliveryValidation = async (data) => {
    try {
        return await AoneService.post(`ops/api/v1/delivery/validations`,data)
    } catch (error) {
        return error;
    }
}
//validate package tracking id
export const validatePackageTrackingId = async (params,data) => {
    try {
        return await AoneService.post(`ops/api/v1/delivery/validations/${params}/validate`,data)
    } catch (error) {
        return error;
    }
}
//submit delivery validation
export const submitDeliveryValidation = async (data) => {
    try {
        return await AoneService.post(`ops/api/v1/delivery/validations/submit`,data)
    } catch (error) {
        return error;
    }
}
//make OFD
export const makeOfd = async (params) => {
    try {
        return await AoneService.get(`ops/api/v1/delivery/validation/ofd/${params}`)
    } catch (error) {
        return error;
    }
}
// count tasks for courier
export const countTasks = async (params) => {
    try {
        return await AoneService.get(`ops/api/v1/delivery/validations/${params}/count`)
    } catch (error) {
        return error;
    }
}
//export delivery validation
export const exportDeliveryValidation = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/delivery/validations/export${params}`, {
        responseType: "blob",
      });
    } catch (error) {
      return error;
    }
  };
  export const exportDelValidation = async (params) => {
    try {
      return await AoneService.get(`ops/api/v2/delivery/validations/export${params}`, {
        responseType: "blob",
      });
    } catch (error) {
      return error;
    }
  };
  //delete delivery validation
  export const deleteDeliveryValidation = async (params) => {
    try {
        return await AoneService.delete(`ops/api/v1/delivery/validations/scans/${params}`)
    } catch (error) {
        return error;
    }
}
//remove delivery validated scans
export const removeDeliveryValidation = async (params) => {
    try {
        return await AoneService.delete(`ops/api/v1/delivery/validations/${params}`)
    } catch (error) {
        return error;
    }
}

//courier debreifing
export const startCourierDebreif = async (data) => {
    try {
        return await AoneService.post(`ops/api/v1/debriefing`,data)
    } catch (error) {
        return error;
    }
}
//count courier datas
export const countCourierDebreif = async (params) => {
    try {
        return await AoneService.get(`ops/api/v1/debriefing/${params}/count`)
    } catch (error) {
        return error;
    }
}
//Download courier debrief
export const downloadDebriefProof = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/debriefing/${params}/download`,
      {
       responseType: "blob"
      }
    );
    } catch (error) {
      return error;
    }
  };
//add debreifing
export const addDebreifing = async (data) => {
    try {
        return await AoneService.post(`ops/api/v1/debriefing/add`,data)
    } catch (error) {
        return error;
    }
}
//get debriefing
export const getDebreif = async (params) => {
    try {
        return await AoneService.get(`ops/api/v1/debriefing/scans${params}`)
    } catch (error) {
        return error;
    }
}
//submit debreifing
export const submitDebreifing = async (params) => {
    try {
        return await AoneService.post(`ops/api/v1/debriefing/submit?debriefingCode=${params}`)
    } catch (error) {
        return error;
    }
}
//delete debreifing
export const deleteDebreifing = async (params) => {
    try {
        return await AoneService.delete(`ops/api/v1/debriefing/${params}`)
    } catch (error) {
        return error;
    }
}
//get history
export const getDebreifHistory = async (params) => {
    try {
        return await AoneService.get(`ops/api/v1/debriefing/history${params}`)
    } catch (error) {
        return error;
    }
}
//export history
export const exportDebreifingHistory = async (params) => {
    try {
      return await AoneService.get(`ops/api/v1/debriefing/history/export${params}`, {
        responseType: "blob",
      });
    } catch (error) {
      return error;
    }
  };

  //delivery validation version 2
  export const getDelValidation = async (params) => {
    try {
        return await AoneService.get(`ops/api/v2/delivery/validations${params}`)
    } catch (error) {
        return error;
    }
}
  //delivery validation version 3
  export const getDlValidation = async (params) => {
    try {
        return await AoneService.get(`ops/api/v2.1/delivery/validations${params}`)
    } catch (error) {
        return error;
    }
}
//get delivery audit by courier
export const getDeliveryAudit = async (params) => {
    try {
        return await AoneService.get(`ops/api/v2/delivery/validations/employee/${params}`)
    } catch (error) {
        return error;
    }
}
export const getDeliveryAuditbyCode = async (params) => {
    try {
        return await AoneService.get(`ops/api/v2/delivery/validations/${params}`)
    } catch (error) {
        return error;
    }
}
//unassign courier from dl validation
export const deleteDeliveryAudit = async (params) => {
    try {
        return await AoneService.delete(`ops/api/v2/delivery/validations/scans/${params}`)
    } catch (error) {
        return error;
    }
}

//Debreifing version two------
//Start debreifing
export const startDebreifing = async (data) => {
    try {
        return await AoneService.post(`ops/api/v2/debriefing`,data)
    } catch (error) {
        return error;
    }
}
//Get all assigned packages
export const getAssignedPackages = async (params,data) => {
    try {
        return await AoneService.post(`ops/api/v2/debriefing/${params}/packages`,data)
    } catch (error) {
        return error;
    }
}
//Get debriefing scans
export const getDebreifingScans = async (params) => {
    try {
        return await AoneService.get(`ops/api/v2/debriefing/${params}/scans`)
    } catch (error) {
        return error;
    }
}
//Scan package level
export const scanPackageLevel = async (params,data) => {
    try {
        return await AoneService.post(`ops/api/v2/debriefing/${params}/scans`,data)
    } catch (error) {
        return error;
    }
}
//Discrepancy
export const getDiscrepancyScans = async (data) => {
    try {
        return await AoneService.post(`ops/api/v2/debriefing/discrepancy`,data)
    } catch (error) {
        return error;
    }
}
//Submit debriefing
export const submitDebrief = async (data) => {
    try {
        return await AoneService.post(`ops/api/v2/debriefing/submit`, data)
    } catch (error) {
        return error;
    }
}
//Discrepancy lookup
export const getDiscrepancies = async () => {
    try {
        return await AoneService.get(`ops/api/v1/lookups/DiscrepancyReasonV2`)
    } catch (error) {
        return error;
    }
}
//get delivery sheets
export const getDeliverySheets = async (params) => {
    try {
        return await AoneService.get(`ops/api/v1/delivery/task/sheets${params}`)
    } catch (error) {
        return error;
    }
}
//Debriefing Report
//Get debriefing report
export const getDebriefingReport = async (params) => {
    try {
        return await AoneService.get(`ops/api/v2/debriefing/report${params}`)
    } catch (error) {
        return error;
    }
}
//debrief count
export const getDebriefingCount = async (params) => {
    try {
        return await AoneService.get(`ops/api/v2/debriefing/report/aggregate${params}`)
    } catch (error) {
        return error;
    }
}
//Show the details of problematic shipments defined
export const getDebriefingProblems = async (params) => {
    try {
        return await AoneService.get(`ops/api/v2/debriefing/report/${params}/problematic-shipments`)
    } catch (error) {
        return error;
    }
}
//Download debriefing report
export const downloadDebriefingReport = async (params) => {
    try {
      return await AoneService.get(`ops/api/v2/debriefing/report/download${params}`, {
        responseType: "blob",
      });
    } catch (error) {
      return error;
    }
  };
//Complete debriefing report
export const completeDebriefingReport = async (params) => {
    try {
        return await AoneService.put(`ops/api/v2/debriefing/report/${params}/complete`)
    } catch (error) {
        return error;
    }
}
//Debriefing revoke completion
export const revokeDebriefing = async (params) => {
    try {
        return await AoneService.put(`ops/api/v2/debriefing/report/${params}/revoke-completion`)
    } catch (error) {
        return error;
    }
}
//upload proof
  export const uploadProof = async (params,data) => {
    try {
      return await AoneService.post(`ops/api/v1/consignments/${params}/image/604?fileType=PROOF_IMAGE`, data, {
        "Content-Type": "multipart/form-data",
      });
    } catch (error) {
      return error;
    }
  };
